import React from "react";
import './App.module.scss';
import BaseLayout from "./pages/BaseLayout";

function App() {
  return (
    <BaseLayout />
  );
}

export default App;
